import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M533.341 1653.659v-106.666H1920v106.666H533.341zm0-1279.993V267H1920v106.666H533.341zm0 853.329v-106.773H1920v106.773H533.341zM282.345 518.08l75.306-75.413 304.425 304.319-304.425 304.318-75.306-75.306 175.572-175.68h-351.25v853.33H0V693.653h457.917L282.345 518.08zm570.994 282.25V693.663h213.332V800.33H853.34zm426.665 0V693.663h213.332V800.33h-213.332zm426.664 0V693.663H1920V800.33h-213.332z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpLine =
/*#__PURE__*/
function (_Component) {
  _inherits(IconMoveUpLine, _Component);

  function IconMoveUpLine() {
    _classCallCheck(this, IconMoveUpLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconMoveUpLine).apply(this, arguments));
  }

  _createClass(IconMoveUpLine, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveUp",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveUpLine.displayName = "IconMoveUpLine";
  return IconMoveUpLine;
}(Component);

IconMoveUpLine.glyphName = 'move-up';
IconMoveUpLine.variant = 'Line';
IconMoveUpLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveUpLine;
export { IconMoveUpLine };